export default __webpack_public_path__ + "static/media/Group 3181@2x.9a758965.png";